import axios from "axios";
import { getToken } from "./getToken";
import { removeToken } from "./removeToken";
import Routes from "./../routes.json";

const url = process.env.REACT_APP_BACKEND_URL;

const redirectSignIn = () => {
	window.location.replace(Routes.SlidesPage);
};

export const getSlidesList = () =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.get(`${url}/slides/list`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.data.slides);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const updateShareOption = (
	id,
	shareLink,
	shareOption = "",
	accessCode = ""
) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.put(
				`${url}/metadata/share/${id}`,
				{
					shareLink,
					shareOption,
					accessCode,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const updateTitle = (id, title) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.put(
				`${url}/metadata/title/${id}`,
				{
					title,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const createSlides = () =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.post(`${url}/slides/create`, null, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const duplicateSlides = (id) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.post(`${url}/slides/duplicate/${id}`, null, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const getSlides = (id) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.get(`${url}/slides/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const getShareOption = (id) =>
	new Promise((resolve, reject) => {
		axios
			.get(`${url}/metadata/shareoption/${id}`)
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else return reject(response.data?.message || "Unknown Error!");
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const matchAccessCode = (id, accessCode) =>
	new Promise((resolve, reject) => {
		axios
			.post(`${url}/metadata/matchaccesscode/${id}`, {
				accessCode,
			})
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else return reject(response.data?.message || "Unknown Error!");
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const getSlidesMetaData = (id) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.get(`${url}/metadata/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success) return resolve(response.data.data);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const deleteSlides = (id) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.delete(`${url}/slides/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const addSlide = (id, slide, insertIndex) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.post(
				`${url}/slide/${id}`,
				{
					slide,
					insertIndex,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const updateSlide = (id, slide) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.put(
				`${url}/slide/${id}`,
				{
					slide,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const deleteSlide = (id, slideid) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.delete(`${url}/slide/${id}/${slideid}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const moveSlide = (id, indexes) =>
	new Promise((resolve, reject) => {
		let token = getToken();
		if (!token) {
			return reject(false);
		}
		axios
			.post(
				`${url}/slide/move/${id}`,
				{
					indexes,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((response) => {
				if (response.data.success)
					return resolve(response.data.success);
				else {
					if (response.data?.message === "token expired") {
						removeToken();
						redirectSignIn();
					}
					return reject(response.data?.message || "Unknown Error!");
				}
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});

export const demoData = (chartType) =>
	new Promise((resolve, reject) => {
		axios
			.get(`${url}/demodata/${chartType}`)
			.then((response) => {
				if (response.data) return resolve(response.data);
				else return reject("Unknown Error!");
			})
			.catch((e) => {
				return reject(e.message || e);
			});
	});
